import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { useSelectedLocation } from '@frontend/payments-hooks';
import { breakpoints } from '@frontend/responsiveness';
import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { PaymentSettingsGroup } from '../atoms/payment-settings-group';
import { PaymentSettingsCard } from '../atoms/payments-card';
import { TerminalAddress } from '../sections/terminal-settings/terminal-address/terminal-address';
import { TerminalSettings } from '../sections/terminal-settings/terminal-settings';
import { TerminalSettingsAction } from '../sections/terminal-settings/terminal-settings-action';
import { useTerminalSettings } from '../sections/terminal-settings/use-terminal-settings';

export const TerminalSettingsGroup = () => {
  const { t } = useTranslation('payments', { keyPrefix: 'settings' });
  const { selectedLocationIds: locationIds } = useAppScopeStore();
  return (
    <section>
      {locationIds.length === 1 ? (
        <PaymentSettingsCard
          locationId={locationIds[0]}
          title={t('Terminals')}
          action={<TerminalSettingsAction locationId={locationIds[0]} />}
        >
          <TerminalAddress />
          <TerminalSettings />
        </PaymentSettingsCard>
      ) : (
        <PaymentSettingsGroup>
          <TerminalSettingsActions />
          <TerminalSettings />
        </PaymentSettingsGroup>
      )}
    </section>
  );
};

const styles = {
  actionHeader: css`
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.spacing(2)};
    @media (min-width: ${breakpoints.medium.min}) {
      flex-direction: row;
      justify-content: space-between;
    }
  `,
};

const TerminalSettingsActions = () => {
  const locationId = useSelectedLocation();
  const { hasTerminalsEnabled } = useTerminalSettings(locationId);

  if (!hasTerminalsEnabled) return;
  return (
    <div css={styles.actionHeader}>
      <TerminalAddress />
      <TerminalSettingsAction locationId={locationId} />
    </div>
  );
};
